// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { InvoiceSummary } from '../../../types/invoice-summary'
import type { Module } from 'vuex'

export type InvoiceState = {
  companyInvoicesForCurrentFilter: InvoiceSummary[],
  totalNoCompanyInvoicesForCurrentFilter: number,
  companyInvoicesCurrentPageNumber: number,
  companyInvoicesPageSize: number,
  companyInvoicesOrderBy: ?string,
  companyInvoicesOrderDirection: ?string,
  companyInvoicesFilterInvoiceNumber: string,
  companyInvoicesFilterInvoiceDate: string,
  companyInvoicesFilterInvoiceYear: string,
  companyInvoicesFilterInvoiceMonth: string
}
const initialState = (): InvoiceState => {
  return {
    companyInvoicesForCurrentFilter: [],
    totalNoCompanyInvoicesForCurrentFilter: 0,
    companyInvoicesCurrentPageNumber: 0,
    companyInvoicesPageSize: 10,
    companyInvoicesOrderBy: null,
    companyInvoicesOrderDirection: null,
    companyInvoicesFilterInvoiceNumber: '',
    companyInvoicesFilterInvoiceDate: '',
    companyInvoicesFilterInvoiceMonth: '',
    companyInvoicesFilterInvoiceYear: ''
  }
}

export type InvoiceModule = Module<InvoiceState>

const companyModule: InvoiceModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default companyModule



// WEBPACK FOOTER //
// ./src/store/modules/invoice/index.js